import ApolloClient from 'apollo-boost';

export const createApolloClient = () => {
  return new ApolloClient({
    uri: 'https://api.graph.cool/simple/v1/cjhwulr4f12rm016803yujj3k',
  });
};


// WEBPACK FOOTER //
// ./src/utils/create-apollo-client.ts